import * as React from "react";
const LabradorSvg = (props) => (
  <div>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="48px"
      height="48px"
      viewBox="0 0 1024 1024"
      enable-background="new 0 0 48 48"
      // xml:space="preserve"
    >
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M524.219482,607.029297 
	C551.005615,607.327698 577.337280,607.494141 603.630432,607.318604 
	C641.608459,607.065002 679.588196,607.391907 717.564941,606.986084 
	C728.552551,606.868591 739.566772,607.503235 750.529724,607.360962 
	C764.542786,607.179077 773.324158,617.451782 771.096375,632.671082 
	C767.179749,659.428528 763.274719,686.187988 759.245239,712.928528 
	C755.092712,740.485046 750.405701,767.967407 746.694580,795.581970 
	C743.952881,815.982666 740.686584,836.297791 737.816772,856.674316 
	C737.271729,860.544250 738.627014,862.766968 742.912537,862.670593 
	C751.846130,862.469666 760.858643,863.620239 769.345581,859.240601 
	C778.797546,854.362915 783.010559,846.444885 783.591125,836.293640 
	C783.895142,830.978149 783.684204,825.630920 783.638977,820.298584 
	C783.612915,817.221741 783.434082,814.012695 787.243652,813.002747 
	C791.205627,811.952393 795.016052,813.098389 796.753540,816.681458 
	C800.544617,824.499329 803.170105,832.731934 801.976746,841.684448 
	C801.363281,846.286194 800.800537,850.896179 800.320068,855.513428 
	C800.006958,858.522461 800.958435,859.950867 804.354614,858.792969 
	C816.938049,854.502625 825.814636,843.915588 825.842896,830.725952 
	C825.888245,809.540955 814.984863,794.197693 800.980530,780.294067 
	C792.164612,771.541504 781.952515,764.639099 770.355591,759.983521 
	C767.864319,758.983459 766.701416,757.954041 767.396362,754.849121 
	C768.552368,749.684998 768.987122,744.359802 769.733643,739.103516 
	C770.150696,736.167297 771.692505,734.938904 774.595520,736.092529 
	C811.232727,750.651489 838.580139,774.577026 849.117554,813.730530 
	C859.720764,853.128113 834.153015,877.830872 802.379883,884.319580 
	C794.888184,885.849487 787.231812,886.275330 779.565674,886.398682 
	C766.745728,886.604980 753.929077,887.013062 741.109375,887.240723 
	C738.536621,887.286316 736.572510,887.912903 735.512573,890.465027 
	C730.806763,901.796631 721.500549,905.284851 710.154968,905.284180 
	C660.827026,905.281189 611.499084,905.283264 562.171143,905.284363 
	C480.513397,905.286194 398.855591,905.240356 317.197968,905.343323 
	C304.969849,905.358765 294.717590,902.551636 289.698486,889.972900 
	C288.723969,887.530518 286.571716,887.364258 284.289734,887.315735 
	C270.805206,887.028809 257.315369,886.840942 243.840515,886.293579 
	C231.024796,885.773010 218.277267,884.591858 206.426544,878.983704 
	C180.974197,866.938904 169.565109,843.220459 176.255661,815.843262 
	C184.265091,783.069336 204.501907,759.889282 233.462830,743.720276 
	C239.961243,740.092224 246.628769,736.747314 254.482254,734.505005 
	C256.070892,742.188599 257.154358,749.477234 257.467560,756.862976 
	C257.590454,759.760986 254.713913,759.913269 252.900192,760.755005 
	C236.713654,768.266602 223.012604,778.848389 212.644348,793.455261 
	C204.466187,804.976685 199.757843,817.409668 199.992889,832.058228 
	C200.189407,844.306946 211.564148,857.906433 225.643051,859.350952 
	C226.081131,853.552368 224.929855,847.875305 224.095093,842.277832 
	C222.777252,833.440918 225.074692,825.477661 228.629120,817.659546 
	C229.651978,815.409668 231.642075,814.104309 233.845276,813.230286 
	C238.555756,811.361572 242.205093,813.736145 242.308762,818.802673 
	C242.421219,824.299866 242.324142,829.801025 242.349182,835.300354 
	C242.421448,851.179749 253.452606,862.360901 269.351013,862.635498 
	C273.682556,862.710327 278.016998,862.608826 282.348969,862.669617 
	C285.976624,862.720520 287.453369,861.306824 286.895538,857.463745 
	C284.631683,841.867981 282.618042,826.236023 280.389130,810.634949 
	C277.903198,793.234924 275.258209,775.857666 272.729279,758.463684 
	C269.936768,739.256592 267.236938,720.036072 264.423035,700.832153 
	C261.898529,683.603455 259.276001,666.389099 256.692535,649.169067 
	C255.806549,643.263245 254.980118,637.347351 254.000504,631.456970 
	C251.897415,618.811523 259.760284,608.148315 272.576355,607.675049 
	C295.029602,606.845886 317.504181,606.597473 339.978912,607.368774 
	C345.623260,607.562500 351.296875,606.835266 356.945679,606.978882 
	C382.575928,607.630493 408.209473,606.928345 433.847748,607.284729 
	C457.306885,607.610840 480.818359,607.353210 504.302765,606.992859 
	C510.788116,606.893372 517.264832,608.197571 524.219482,607.029297 
M705.392456,881.642273 
	C707.058838,881.640442 708.731934,881.542053 710.390320,881.656067 
	C714.382568,881.930603 715.478455,879.708374 715.802124,876.173523 
	C716.285217,870.897400 713.488342,870.318481 709.145325,870.321289 
	C579.003845,870.406311 448.862274,870.394836 318.720734,870.408630 
	C317.058655,870.408813 315.341797,870.296753 313.746033,870.658508 
	C310.579620,871.376221 309.072784,872.988708 309.786499,876.766235 
	C310.762207,881.929749 314.186127,881.671875 317.993469,881.670898 
	C446.801971,881.639648 575.610474,881.643677 705.392456,881.642273 
M545.721130,734.733215 
	C542.077942,719.182678 528.665955,707.593262 513.571045,707.422302 
	C499.267670,707.260193 488.600586,713.765442 482.128571,726.472839 
	C475.556610,739.376343 477.286469,751.902527 486.384064,762.794739 
	C495.251648,773.411560 506.942688,777.706543 520.782227,774.368225 
	C537.748962,770.275635 549.641296,751.777527 545.721130,734.733215 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M319.125916,309.771545 
	C318.106567,322.169891 317.597595,334.128235 317.289032,346.108215 
	C316.736481,367.561798 310.883759,387.466248 298.409119,405.089844 
	C292.518829,413.411346 284.859192,419.197784 273.975922,419.418488 
	C262.929382,419.642517 255.261917,414.487640 250.279663,404.975189 
	C245.519455,395.886688 243.496582,385.891144 241.276169,376.013336 
	C236.444046,354.516968 228.020523,334.198975 221.165604,313.364380 
	C216.532700,299.283264 212.758865,284.780670 212.980026,269.945557 
	C213.263565,250.927063 220.648178,234.433243 234.327530,220.860199 
	C243.589874,211.669815 254.846603,205.585983 266.078430,199.376251 
	C283.427307,189.784607 300.790466,180.221344 317.718781,169.885284 
	C326.581696,164.473816 334.119171,157.341827 342.560669,151.396820 
	C362.726868,137.194565 382.938324,136.950104 403.304413,150.991592 
	C406.354034,153.094147 408.656799,153.224091 411.864075,151.555939 
	C432.296356,140.928802 454.174835,134.912231 476.869110,131.574799 
	C491.208893,129.466003 505.642975,128.177917 520.105347,128.799194 
	C553.149292,130.218658 585.076233,136.675690 614.834106,151.745209 
	C617.815735,153.255127 619.881653,153.035004 622.523926,151.194519 
	C643.189209,136.799728 664.963196,136.258804 684.844666,152.356339 
	C710.212341,172.895920 739.084045,187.350464 767.139587,203.280243 
	C781.423462,211.390579 794.275757,220.711960 802.670776,235.284088 
	C813.122742,253.426605 814.733704,272.556183 810.027588,292.643372 
	C807.026611,305.452423 803.573547,318.103333 798.673828,330.321136 
	C790.781555,350.001190 786.254456,370.633026 781.296753,391.147400 
	C780.160706,395.848022 778.601807,400.409088 776.393555,404.733795 
	C768.353394,420.480103 750.079407,424.387268 736.253967,413.328705 
	C725.809875,404.974854 720.338928,393.407471 715.728516,381.349426 
	C710.880920,368.670868 708.286926,355.651672 708.547546,341.896973 
	C709.392273,297.307098 698.438599,255.623962 676.507812,216.805801 
	C674.119080,212.577606 671.367737,208.627014 667.995117,205.129379 
	C666.758362,203.846771 665.585083,202.378036 662.446655,202.310059 
	C675.290283,229.216888 684.303467,256.771271 690.459839,285.666595 
	C686.213989,286.124573 684.250488,283.710236 682.245056,281.640503 
	C673.605286,272.723419 663.854858,265.308746 653.106079,259.083649 
	C641.595276,252.417175 629.004700,249.725571 616.028931,248.403351 
	C609.131958,247.700546 608.673340,247.434891 607.640686,240.600296 
	C605.677795,227.609451 603.211609,214.796051 597.888000,202.597031 
	C587.894897,179.698090 571.389404,165.039612 546.475769,160.647476 
	C522.137451,156.356750 497.864532,156.406265 473.758911,162.374680 
	C458.930878,166.046051 447.288483,174.066772 438.498779,186.782288 
	C428.393433,201.401062 423.205109,217.629395 420.302856,234.892044 
	C418.317444,246.701309 418.162964,246.955032 406.685547,248.637589 
	C391.741425,250.828354 377.198517,253.865356 364.693146,263.064911 
	C357.172394,268.597565 349.714630,274.182770 343.236786,280.971649 
	C341.455933,282.838013 339.802979,285.160767 335.767151,284.847351 
	C341.357971,256.496643 350.647247,229.589645 363.013000,203.387238 
	C359.733521,202.347305 358.701385,204.406830 357.482208,205.725235 
	C349.653870,214.190582 345.210052,224.710663 340.252136,234.860229 
	C329.659607,256.544922 322.882904,279.440613 319.494141,303.331360 
	C319.214752,305.300873 319.282684,307.319641 319.125916,309.771545 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M496.362274,341.282776 
	C491.900757,364.268707 484.515564,385.239899 464.016510,398.608337 
	C447.775513,409.199860 429.932404,414.819550 410.443146,415.429321 
	C393.968262,415.944794 378.725494,412.622833 365.173096,402.865845 
	C362.307861,400.803070 359.934723,398.245911 357.508057,395.723145 
	C356.607513,394.786987 355.585876,393.623291 354.086060,394.133087 
	C352.313934,394.735474 352.340820,396.402832 352.362244,397.909882 
	C352.459930,404.777161 353.936615,411.435577 355.836731,417.970337 
	C359.712463,431.299225 365.186584,443.965607 372.402985,455.842560 
	C379.118744,466.895569 382.657654,478.618958 382.479492,491.788879 
	C382.158264,515.533752 389.552551,537.609680 398.905762,559.089905 
	C401.829834,565.805237 404.912537,572.466003 408.269043,578.973022 
	C410.179382,582.676331 408.712463,584.127441 405.407257,585.048645 
	C398.664581,586.927979 392.529388,584.978027 386.749756,581.761536 
	C381.515289,578.848389 376.549530,575.456543 371.369629,572.440063 
	C366.985413,569.886963 365.484528,570.813171 365.340546,575.996277 
	C365.220642,580.310059 365.143433,584.586243 364.596130,588.912048 
	C364.091248,592.902649 362.311890,593.514099 359.053131,593.243042 
	C340.753906,591.721130 322.414856,592.520508 304.092712,592.410522 
	C299.274719,592.381592 294.451141,592.838440 289.634644,593.143188 
	C285.276489,593.418884 283.340759,591.867004 283.574646,587.095337 
	C284.399048,570.276489 289.034271,554.356140 294.590027,538.661316 
	C302.636658,515.929932 315.186127,495.391876 326.408203,474.211578 
	C326.720184,473.622772 327.018616,473.021881 327.385712,472.467957 
	C335.190277,460.691376 336.769653,449.089111 330.228973,435.555969 
	C322.432159,419.423737 322.104065,401.907318 325.842957,384.306549 
	C328.612183,371.270477 328.427155,357.884399 329.666138,344.664337 
	C331.181458,328.495758 330.968109,312.162384 334.066956,295.715149 
	C339.680115,296.593750 342.427063,292.946167 345.622742,289.371582 
	C361.450104,271.667480 381.185120,261.372620 404.850311,258.389038 
	C432.221985,254.938095 455.943878,261.913635 475.358917,281.982178 
	C480.023743,286.804016 483.960876,292.218353 487.040344,298.137024 
	C488.965271,301.836670 491.578430,303.188599 495.487305,302.681580 
	C498.283539,302.318878 501.128845,302.184784 503.870361,301.578522 
	C511.716644,299.843323 519.414551,301.077332 527.126160,302.411255 
	C534.011780,303.602325 535.587341,302.603546 539.188599,296.550415 
	C552.183655,274.708099 571.297974,261.883087 596.549438,258.593231 
	C628.281433,254.459076 655.321594,263.952545 677.487488,287.089874 
	C681.090698,290.851013 683.534241,295.943420 689.972473,296.012390 
	C691.956970,296.033630 691.961426,298.706024 692.354065,300.482910 
	C694.481689,310.109924 694.661865,319.959991 695.160583,329.707947 
	C696.299561,351.967712 699.026489,374.023041 701.993286,396.083801 
	C704.019897,411.153931 701.120850,425.809387 694.722900,439.338989 
	C689.555847,450.265656 690.296753,459.725952 696.158325,469.975739 
	C705.166809,485.728424 713.778809,501.718628 721.797485,518.021545 
	C732.018555,538.802124 738.431396,560.729187 742.151611,583.498291 
	C743.420166,591.262695 741.504761,593.247803 733.605164,592.921631 
	C711.957703,592.027710 690.309265,591.949402 668.666382,592.979675 
	C664.261108,593.189392 661.350098,592.222717 660.956970,587.071655 
	C660.664001,583.232910 660.748962,579.424927 660.758179,575.600220 
	C660.762085,573.987976 661.399902,572.052551 659.575195,571.075867 
	C657.820190,570.136536 656.336426,571.512695 655.032288,572.400513 
	C648.968994,576.528320 642.943420,580.685425 636.063293,583.414490 
	C629.712952,585.933472 623.408813,587.441223 616.931885,583.418152 
	C617.225708,579.520203 619.345703,576.432678 620.931946,573.213501 
	C630.099304,554.609253 636.886047,535.195435 641.098694,514.890442 
	C642.964050,505.899506 643.174622,496.709473 643.508057,487.607666 
	C643.921021,476.337036 646.606873,466.010712 652.457092,456.368866 
	C661.682617,441.164215 668.173706,424.806763 672.107361,407.468384 
	C673.127869,402.970215 673.133972,398.381195 671.992371,393.932617 
	C668.629150,393.624084 667.359436,395.833527 665.843567,397.482269 
	C654.943787,409.337738 641.057373,414.462311 625.368835,415.344940 
	C606.203369,416.423218 588.039001,412.507446 570.692566,404.292603 
	C547.072693,393.106903 535.224976,373.569427 530.684998,348.724152 
	C530.178833,345.954132 529.980225,343.128754 529.504883,340.351990 
	C528.172180,332.566864 521.613342,327.480530 512.897949,327.392883 
	C504.328796,327.306732 498.166534,332.331909 496.362274,341.282776 
M555.688721,357.881348 
	C556.568909,360.214020 557.316711,362.607117 558.349915,364.869965 
	C568.354065,386.781311 599.319458,400.885498 624.792664,395.251282 
	C664.954651,386.368134 681.651917,341.239105 660.446716,306.353516 
	C650.625671,290.196655 635.783142,281.535126 616.961487,279.875336 
	C598.299744,278.229614 581.405029,282.522766 568.203613,296.450684 
	C551.649536,313.915802 548.368164,334.515259 555.688721,357.881348 
M358.328796,357.232819 
	C365.671295,380.688416 387.148285,396.613922 411.500854,396.660706 
	C439.247620,396.713989 462.978882,378.791504 470.187836,351.890839 
	C473.967773,337.785675 474.861664,323.479462 467.662140,310.119415 
	C450.996887,279.193817 415.268616,272.963470 389.166321,284.950958 
	C362.167480,297.350189 350.896545,325.431488 358.328796,357.232819 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M592.193542,528.395813 
	C580.972351,531.781738 572.629211,537.279724 566.229126,547.658325 
	C558.560974,560.093201 544.546692,564.116455 530.560791,566.209473 
	C515.415955,568.475952 500.428497,567.420471 485.587341,563.488464 
	C471.121552,559.656006 460.037018,551.583191 453.123383,538.255371 
	C451.174011,534.497498 448.089752,533.345337 444.472412,532.352356 
	C428.323303,527.919434 415.173462,518.911438 405.275787,505.476562 
	C395.067993,491.620819 394.759674,476.543732 400.947662,460.978668 
	C402.016937,458.289001 403.916107,456.362488 407.044220,456.903107 
	C410.285492,457.463257 410.308044,460.145081 410.347809,462.744415 
	C410.436340,468.536987 409.480865,474.507324 412.226685,479.948486 
	C419.669525,494.697540 440.704620,513.971619 461.031952,512.799011 
	C479.415100,511.738525 500.300995,493.392853 502.553314,475.141174 
	C502.952179,471.908813 501.195496,470.606140 498.539124,469.846069 
	C491.934082,467.956055 485.666931,465.239563 479.913452,461.519073 
	C468.883881,454.386658 461.632080,444.805603 460.549683,431.196106 
	C459.652069,419.909607 465.084656,412.523438 474.517120,407.437622 
	C483.482788,402.603516 493.350098,400.759949 503.278870,399.939301 
	C517.107178,398.796356 530.880127,399.676086 544.135254,404.375763 
	C546.789307,405.316742 549.398010,406.497803 551.846802,407.886780 
	C564.326538,414.965393 568.867432,428.118835 563.095459,441.279724 
	C556.626587,456.029358 544.654297,464.453125 529.729065,469.228302 
	C522.611633,471.505463 522.926880,471.567352 524.947632,478.629486 
	C530.383301,497.626160 543.139282,508.255737 562.074707,512.046265 
	C574.655945,514.564819 585.415161,509.812256 595.110779,502.574402 
	C603.258728,496.491852 611.094177,489.799683 613.781982,479.257294 
	C615.139160,473.933960 615.606567,468.482422 615.229065,462.961823 
	C615.065491,460.570557 614.295715,457.603912 617.804260,456.853302 
	C621.267517,456.112366 623.611389,457.716187 624.686035,461.072601 
	C630.518982,479.289581 630.679565,496.366608 615.529236,510.841003 
	C608.502991,517.553772 601.287903,523.874634 592.193542,528.395813 
M546.907715,530.144043 
	C535.300659,526.322266 524.954163,520.673828 517.502747,510.546295 
	C513.629456,505.281952 512.596130,505.208466 508.687012,510.335510 
	C501.806915,519.359131 492.901184,525.467468 482.544189,529.742737 
	C481.110016,530.334778 479.191986,530.511414 478.661346,532.776855 
	C480.921295,537.017700 484.839050,539.548218 489.227692,541.179810 
	C500.558411,545.392212 512.126221,547.990356 524.348328,545.589783 
	C532.618713,543.965393 540.627380,541.836121 546.685791,535.498840 
	C547.906738,534.221741 550.810913,532.658936 546.907715,530.144043 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M580.869995,315.870422 
	C598.323425,300.152496 625.069641,307.505005 629.603882,329.626434 
	C633.439758,348.340881 627.127014,363.767578 607.571655,367.131256 
	C592.700684,369.689178 582.269348,364.846863 576.261841,353.946594 
	C569.868896,342.347046 571.691833,326.482452 580.869995,315.870422 
M608.047119,323.459381 
	C602.842163,323.813629 600.195251,326.325714 600.565369,330.560028 
	C600.980957,335.315582 604.420532,338.923859 607.910278,338.265259 
	C611.595093,337.569855 614.427917,332.981689 613.515808,329.006775 
	C612.918762,326.404968 611.204773,324.669891 608.047119,323.459381 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M436.685913,365.071289 
	C427.019348,368.731628 417.702087,368.466431 408.646362,364.612396 
	C399.476349,360.709686 395.129639,352.837738 393.819916,343.517029 
	C390.857513,322.435028 404.396820,307.408051 425.653625,307.644867 
	C439.578796,307.799957 450.267395,318.097900 452.226715,333.246796 
	C453.957336,346.627808 448.175476,358.682892 436.685913,365.071289 
M437.618622,329.039246 
	C437.227783,325.697174 434.909424,324.164490 432.000671,323.560120 
	C429.426117,323.025208 427.542267,324.538483 426.192352,326.587097 
	C424.283234,329.484314 424.006592,332.495087 426.262543,335.339172 
	C427.974487,337.497375 430.011810,339.121887 433.088287,338.118652 
	C437.215607,336.772766 438.038422,333.638031 437.618622,329.039246 
z"
      />
    </svg>
  </div>
);
export default LabradorSvg;
